import React from 'react'
import CustomPath from './CustomPath'

const OUTLINE_PATH =
    'M10 16L0 0L45.4492 0L56 16L45.4492 32L0 32L10 16ZM46.417 16L41.1416 8H14.4346L19.4336 16L14.4346 24L41.1416 24L46.417 16Z'
const RAW_WIDTH = 56
const RAW_HEIGHT = 32

/**
 * Chevron Right cutout shape component
 * @type {import('./CustomPath').CustomPath}
 */

export const ChevronRightCutoutShape = React.forwardRef((props, ref) => {
    return <CustomPath {...props} ref={ref} data={OUTLINE_PATH} rawWidth={RAW_WIDTH} rawHeight={RAW_HEIGHT} />
})

export default ChevronRightCutoutShape
